import store from '../../../core/store';

export const listPermissionsManager = () => {
  return store.dispatch({
    action: 'table.company_roles_and_permissions/LIST_PERMISSIONS_MANAGER',
    method: 'GET',
    endpoint: '/permission_manager',
  });
};

export const listUsers = () => {
  return store.dispatch({
    action: 'table.company_roles_and_permissions/LIST_USERS',
    method: 'GET',
    endpoint: '/permission_manager/list_users',
  });
};

export const listRoles = () => {
  return store.dispatch({
    action: 'table.company_roles_and_permissions/LIST_ROLES',
    method: 'GET',
    endpoint: '/permission_manager/list_roles',
  });
};

export const listRolePermissions = (user_id) => {
  return store.dispatch({
    action: 'table.company_roles_and_permissions/LIST_ROLES_PERMISSIONS',
    method: 'GET',
    endpoint: '/permission_manager/list_role_permissions/' + user_id,
  });
};

export const listUserPermissions = (user_id) => {
  return store.dispatch({
    action: 'table.company_roles_and_permissions/LIST_USER_PERMISSIONS',
    method: 'GET',
    endpoint: '/permission_manager/list_user_permissions/' + user_id,
  });
};

export const listUserRoles = (user_id) => {
  return store.dispatch({
    action: 'table.company_roles_and_permissions/LIST_USER_ROLES',
    method: 'GET',
    endpoint: '/permission_manager/list_user_roles/' + user_id,
  });
};

export const saveRolePermissions = (formData, user_id) => {
  return store.dispatch({
    action: 'table.company_roles_and_permissions/SAVE_ROLES_PERMISSIONS',
    method: 'PUT',
    endpoint: '/permission_manager/save_user_permissions/' + user_id,
    data: formData,
  });
};

export const assignUserRoles = (formData, user_id) => {
  return store.dispatch({
    action: 'table.company_roles_and_permissions/ASSIGN_USER_ROLES',
    method: 'PUT',
    endpoint: '/permission_manager/assign_user_roles/' + user_id,
    data: formData,
  });
};
